import { Flex } from "antd";
import Icon1 from "../_icons/email-pin-icon.svg";
import Icon2 from "../_icons/file-pin-icon.svg";
export default function Hero() {
  return (
    <Flex
      justify="center"
      align="center"
      className="bg-gradient-to-l from-teal-700 to-gray-800 h-48 lg:h-64 relative" // Added relative here
    >
      {/* Background decorative images - now positioned relative to the full hero */}
      <img
        className="absolute bottom-4 left-12 md:left-20 lg:left-52 w-8 lg:w-16 brightness-50"
        src={Icon1}
        alt=""
      />
      <img
        className="absolute top-5 right-12  lg:right-24 w-8 lg:w-16 brightness-75"
        src={Icon2}
        alt=""
      />

      <div className="container relative z-10 text-center">
        {" "}
        {/* z-10 to stay on top */}
        <div className="text-center justify-start text-white text-2xl lg:text-4xl font-semibold">
          রেজিস্টার করুন
        </div>
        <div className="text-center justify-start text-white text-sm lg:text-base font-bold">
          আজই শুরু করুন আপনার স্কি
          <span className="opacity-0 absolute">.</span>ল ডেভেলপমেন্টের যাত্রা
        </div>
      </div>
    </Flex>
  );
}
